const htmlIcon = new URL("../images/icon-html.svg", import.meta.url).href;
const cssIcon = new URL("../images/icon-css.svg", import.meta.url).href;
const jsIcon = new URL("../images/icon-js.svg", import.meta.url).href;
const accessibilityIcon = new URL(
  "../images/icon-accessibility.svg",
  import.meta.url,
).href;

export const icons = {
  HTML: htmlIcon,
  CSS: cssIcon,
  JavaScript: jsIcon,
  Accessibility: accessibilityIcon,
};

export const backgroundColors = {
  HTML: "bg-orange-50",
  CSS: "bg-green-100",
  JavaScript: "bg-blue-50",
  Accessibility: "bg-purple-100",
};
